"use client";

import { RenderBuilderWithSSRProps } from "@faire/builder-core/BuilderComponents/types";
import { FaireHelmet } from "@faire/deprecated-retailer-visitor-shared/components/Helmet/index";
import { useRetailer } from "@faire/deprecated-retailer-visitor-shared/hooks/retailer/useRetailer";
import * as RetailerPaths from "@faire/deprecated-retailer-visitor-shared/paths/index";
import { getSessionCountry } from "@faire/deprecated-retailer-visitor-shared/serialized-data/getSessionCountry";
import { LoggedOutHomePageBase } from "@faire/deprecated-retailer-visitor-shared/views/home/logged-out-homepage/LoggedOutHomePageBase";
import { getLocationOrThrow } from "@faire/web/common/globals/getLocation";
import { useStrictLocalization } from "@faire/web/common/localization";
import { getCountryDisplayNameFromSessionCountry } from "@faire/web/common/localization/getCountryDisplayNameFromSessionCountry";
import { DEPRECATED_backwardsCompatibleValues } from "@faire/web/common/localization/localize";
import { Flex } from "@faire/web/slate/Layout";
import qs from "query-string";
import React from "react";
import { Redirect, useLocation } from "react-router-dom";

const HardRedirect = ({ to }: { to: string }) => {
  getLocationOrThrow().href = to;
  return null;
};

export const LoggedOutHomePage: React.FC<{
  builderVideoHeaderProps: RenderBuilderWithSSRProps | null;
}> = ({ builderVideoHeaderProps }) => {
  const { strictLocalize } = useStrictLocalization();
  const location = useLocation();
  const countryDisplayName = getCountryDisplayNameFromSessionCountry(
    getSessionCountry(),
    strictLocalize
  );

  const getTitle = () => {
    return countryDisplayName
      ? strictLocalize(
          {
            id: "OhGAhW",
            description: {
              text: "Logged out homepage title with country tag",
            },
            defaultMessage:
              "Faire {country} - Online Wholesale Marketplace for Retailers & Brands",
          },
          DEPRECATED_backwardsCompatibleValues({ country: countryDisplayName })
        )
      : strictLocalize({
          id: "2OIthz",
          description: { text: "Logged out homepage title" },
          defaultMessage:
            "Faire - Online Wholesale Marketplace for Retailers & Brands",
        });
  };

  const { retailer } = useRetailer();
  const query = qs.parse(location.search);

  if (query.ad) {
    return <HardRedirect to={`/ad/${query.ad}`} />;
  }

  if (retailer && retailer.token) {
    return <Redirect to={RetailerPaths.home(query)} />;
  }

  return (
    <Flex>
      <FaireHelmet
        alignOpenGraphTitleDescription
        title={getTitle()}
        description={strictLocalize({
          id: "dTL5/q",
          description: {
            text: "description for website",
          },
          defaultMessage:
            "Hundreds of thousands of retailers are buying wholesale products online with Faire. Order from thousands of independent wholesale vendors with net 60 terms & free returns today.",
        })}
      />
      <LoggedOutHomePageBase
        builderVideoHeaderProps={builderVideoHeaderProps}
      />
    </Flex>
  );
};
